import {AbstractAdminEntityService} from "../../admin/AbstractAdminEntityService";
import {
    ScheduledTournamentConfig,
    ListScheduledTournamentResponse,
    TournamentConstraints, TimeZone, TournamentSchedule, TournamentScheduleTime, TournamentOperator
} from "../../../../generated/protocol";
import {AdminEntityService} from "../../admin/AdminEntityService";
import {injectable} from "inversify";

export const TOURNAMENT_CONSTRAINTS_SERVICE_NAME = "tournamentConstraintsService";

export interface TournamentConstraintsService extends AdminEntityService<TournamentConstraints> {
    getConstraintsByUser(): Promise<TournamentConstraints>;

    getTimeZones(): Promise<TimeZone[]>;

    calculateSchedule(schedule: TournamentSchedule): Promise<TournamentScheduleTime[]>;

    getTournamentOperators(): Promise<TournamentOperator[]>;
}

@injectable()
export class TournamentConstraintsServiceImpl extends AbstractAdminEntityService<ScheduledTournamentConfig, ListScheduledTournamentResponse> implements TournamentConstraintsService {


    constructor() {
        super("/poker/tournament/constraints");
    }

    getConstraintsByUser(): Promise<TournamentConstraints> {
        console.log("GET = ", this.entityPath + "/user");
        return this.http.doGet(this.entityPath + "/user");
    }

    getTournamentOperators(): Promise<TournamentOperator[]> {
        return this.http.doGet(this.entityPath + "/tournament-operators")
    }

    getTimeZones(): Promise<TimeZone[]> {
        return this.http.doGet(this.entityPath + "/timezones");
    }

    calculateSchedule(schedule: TournamentSchedule): Promise<TournamentScheduleTime[]> {
        return this.http.doPost(this.entityPath + "/schedule", schedule);
    }

}


// WEBPACK FOOTER //
// ./src/app/service/poker/tournament/TournamentConstraintsService.ts